import type { FC } from 'react';
import InsuranceIcon from '@material-ui/icons/ReceiptOutlined';
import TrashIcon from '@material-ui/icons/DeleteOutlined';
import { IconButton } from '@material-ui/core';
import { InsuranceInput } from '../../Forms/InsuranceForm/types';

interface Props {
  insurance: InsuranceInput;
  onDelete?: (id: string) => void;
  onEdit?: () => void;
}

const InsuranceSummaryItem: FC<Props> = ({ insurance, onDelete, onEdit }) => {
  const handleDelete = () => {
    if (insurance.id) {
      onDelete?.(insurance.id);
    }
  };
  return (
    <div onClick={onEdit} className="flex items-center justify-between px-3 py-2 hover:bg-gray-50 hover:cursor-pointer">
      <div className="flex items-top">
        <InsuranceIcon className="text-blue-800 mr-4" />
        <div className="font-bold">{insurance.company}</div>
      </div>
      {onDelete && (
        <div>
          <IconButton
            aria-label="delete"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              handleDelete();
            }}
          >
            <TrashIcon className="text-red-500" />
          </IconButton>
        </div>
      )}
    </div>
  );
};

export default InsuranceSummaryItem;
